/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Giveaway_Effect_BodyInputs */



/**
* | output |
* | --- |
* | "Every giveaway lands on the timeline, so you can see what it did for activity." |
*
* @param {Features_Giveaway_Effect_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_giveaway_effect_body = /** @type {((inputs?: Features_Giveaway_Effect_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Giveaway_Effect_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Каждый розыгрыш появляется на хронологии, и видно, как он повлиял на активность.")
	return /** @type {LocalizedString} */ ("Every giveaway lands on the timeline, so you can see what it did for activity.")
});